module.exports = __webpack_public_path__ + "img/icon-anesthesia.baca8bf3.png";